<template>
  <view class="container">
    <view class="choosed">
      <text>已选：</text>
      <view
        class="choosed-item"
        wx:for="{{citys}}"
        wx:key="index"
        bindtap="onDelete(item)"
      >{{item.city_name}}<es-icon style="margin-left:4px" size="12" name="close" color="#666" /></view>
    </view>
    <view class="btns">
      <view class="btns-item" bindtap="onCancel">取消</view>
      <view class="btns-item" bindtap="onConfirm">确定</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    properties: {
      citys: {
        type: Array,
        value: () => ([])
      }
    },
    methods: {
      onCancel() {
        this.triggerEvent('cancel')
      },
      onConfirm() {
        this.triggerEvent('confirm')
      },
      onDelete(item) {
        this.triggerEvent('delete', item)
      },
    }
  })
</script>

<style lang="stylus" scoped>
.container
  border-top 1px solid #eee
  width 100%
  padding 8px 20px 0
  background-color #fff
  .choosed
    display flex
    align-items center
    justify-content flex-start
    flex-wrap wrap
    color #333
    font-size 13px
    font-weight 500
    &-item
      color #000
      margin 4px 0
      font-weight 400
      background #F6F7F8
      border-radius 6px
      padding 6px 12px
      display flex
      align-items center
      margin-right 8px
      &:last-child
        margin-right 0
.btns
  padding 8px 0 34px
  box-sizing border-box
  display flex
  align-items center
  justify-content space-between
  &-item
    flex 1
    height 50px
    box-sizing border-box
    display flex
    align-items center
    justify-content center
    background #FF6400
    font-family PingFang SC
    font-weight 600
    font-size 16px
    color #fff
    border-radius 10px
    &:first-child
      margin-right 8px
      color #333
      background-color #fff
      border 1px solid #CCCCCC
</style>